import { SocketIoConfig } from 'ngx-socket-io';
import { USER_META } from './user-meta.const';

export const SOCKET_CONFIG: SocketIoConfig = {
  url: window.location.origin,
  options: {
    path: '/ws',
    query: {
      key: localStorage.getItem(USER_META)
        ? JSON.parse(localStorage.getItem(USER_META) as string).jwt
        : '',
    },
    autoConnect: localStorage.getItem(USER_META)
      ? JSON.parse(localStorage.getItem(USER_META) as string).jwt
      : '',
    transports: ['websocket'],
  },
};
